const languages = {
  FR: { label: "FR - Français", value: "FR", lang: "fr" },
  EN: { label: "EN - English", value: "EN", lang: "en" },
};

export default languages;
